import { forwardRef, useEffect, useState } from 'react';
import { Popover as MaterialPopover, PopoverProps } from '@mui/material';

const Popover = forwardRef((props: PopoverProps, ref: PopoverProps['ref']) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const resizeEvent = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', resizeEvent);

        return () => {
            window.removeEventListener('resize', resizeEvent);
        };
    }, []);

    return (
        <MaterialPopover
            {...props}
            ref={ref}
            // `marginThreshold` = '0' is Required for
            // small screens (around 320px width).
            // If it is not set, it defaults to 16px and
            // will move a 100% width popover slightly
            // off the screen.
            marginThreshold={windowWidth <= 337 ? 0 : undefined}
        >
            {props.children}
        </MaterialPopover>
    );
});

export default Popover;
